import { starfishCommonEnvironment } from '@environments/starfish/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the Starfish site, in production environment.
 */
export const environment: AppEnvironment = {
  ...starfishCommonEnvironment,
  production: true,
  apiUrl: 'https://api.analytecare.com',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyDIEZHrvUCVq39wvL0mBOanghqkHIk8cRE',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://www.starfish.com',
    termsOfService: 'https://www.starfish.com/terms-conditions/',
    myAccount: 'https://my-account.starfish.com',
    tests: 'https://www.starfish.com',
    notFound: 'https://www.starfish.com/404',
  },
};
